import ViewExportContainer from '../../ViewExport/ViewExportContainer';

const getTableData = (data, columns) => {
  const headers = columns
    ?.filter(({ id }) => id !== 'link')
    ?.map(({ Header }) => Header);

  const rows = [];

  data.forEach((entry) =>
    rows.push(
      columns
        ?.filter(({ id }) => id !== 'link')
        ?.map(({ accessor }) => String(accessor(entry, true))),
    ),
  );
  return { headers, rows };
};

const CommunitySetupExport = (props) => (
  <ViewExportContainer {...props} getTableData={getTableData} />
);

export default CommunitySetupExport;
